module.exports = __webpack_public_path__ + "statics/img/cate1-2@2x.7eef7e14.png";